import { Box, Typography } from "@mui/material";
import { COLORS, fmtPct, reducedMotion } from "./emsTheme";

/**
 * Half-circle gauge for a percentage (0–100). The arc grows to its value on first paint.
 * value null shows an empty track. showValue false leaves the number out (when the card
 * already shows it) and labels the ends instead.
 */
export const Gauge = ({ value, color = COLORS.purple, label, showValue = true }) => {
    const r = 44, c = Math.PI * r;
    const v = value == null ? 0 : Math.max(0, Math.min(100, value));
    const motion = !reducedMotion();
    return (
        <Box sx={{ position: "relative", width: 120, height: 68, mx: "auto" }} role="img" aria-label={label || (value == null ? "No data" : fmtPct(value))}>
            <svg width="120" height="68" viewBox="0 0 120 68" aria-hidden>
                <path d="M 16 60 A 44 44 0 0 1 104 60" fill="none" stroke="#ECE8F2" strokeWidth="10" strokeLinecap="round" />
                <path d="M 16 60 A 44 44 0 0 1 104 60" fill="none" stroke={color} strokeWidth="10" strokeLinecap="round"
                    strokeDasharray={c} strokeDashoffset={c * (1 - v / 100)}
                    style={{ transition: motion ? "stroke-dashoffset 700ms cubic-bezier(.2,.7,.2,1)" : "none" }} />
            </svg>
            {showValue ? (
                <Typography sx={{ position: "absolute", left: 0, right: 0, bottom: 2, textAlign: "center", fontSize: 18, fontWeight: 700, color: COLORS.ink, fontVariantNumeric: "tabular-nums" }}>
                    {value == null ? "–" : fmtPct(value, 0)}
                </Typography>
            ) : (
                <>
                    <Typography sx={{ position: "absolute", left: 4, bottom: -16, fontSize: 12, color: COLORS.ink3 }}>0%</Typography>
                    <Typography sx={{ position: "absolute", right: 0, bottom: -16, fontSize: 12, color: COLORS.ink3 }}>100%</Typography>
                </>
            )}
        </Box>
    );
};
